/*
 * File: d:\projects\AutoFiFront\src\Content\Home\HomeCardHolder\HomeCardHolder.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday February 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 6th November 2023 11:01:01
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from 'Content/Home/HomeCardHolder/HomeCardHolder.module.css';
import CarSlider from 'Content/Home/HomeCarSlider/HomeCarSlider';
import AboutUs from 'Content/Home/HomeAboutUs/HomeAboutUs';
import Partners from 'Content/Home/Partners/Partners';
import Engagements from 'Content/Home/Engagements/Engagements';
import { BsFillTelephoneInboundFill as Phone } from "react-icons/bs";
import { MdMail } from "react-icons/md";
import { TextFilter } from 'Content/Filters/TextFilter/TextFilterHolder/TextFilterHolder';
import { GetFilters } from 'Utils/UrlParams';
import { useMyContext } from "Content/Main/Main";
import translator from 'MultiLanguage/TranslationWrapper';
import ModalCta from 'Content/Modals/ModalCta/ModalCta';
import RouterPathResolver from 'Config/Router/RouterPathResolver';
import HomeBanner from 'Content/Home/HomeBanner/HomeBanner';

function HomeCardHolder (){
    const location = useLocation();
    const [myFilters, setMyFilters] = useState(GetFilters(location.search));
    const [modalCta, setModalCta] = useState(false);
    const [play, setPlay] = useState(false);
    const handleFilterChange = async (filters: string[], resetPage: boolean) => {
        setMyFilters(filters);
    };

    const urlToNavigate = (filters: string[])=>{
        return `${RouterPathResolver.routeCars.path}?page=1&filters=${filters}`;
    };

    const { setterThemeColor } = useMyContext();
    useEffect(()=>{
        setterThemeColor("");
    },[]);

    const handleToggleCtaModal = (e: React.MouseEvent<HTMLElement>) => {
        setModalCta(false);
    };
    useEffect(()=>{
        setPlay(true);
    },[]);

    return(
        <React.Fragment>
            <div className={`${styles.homeHolder}`}>
                <div>
                    <div className={`${styles.homeText}`}>
                        <h1 className={`${styles.homeTitle}`}>{translator.decode("home.title")}</h1>
                        <p className={`${styles.homeSubTitle}`}>{translator.decode("home.subTitle")}</p>
                        <div className={`${styles.filters}`}>
                            <TextFilter id="Filters" themeColor={""} curFilters={myFilters} filtersSelected={handleFilterChange}/>
                            <NavLink className={`${styles.btnGoTo}`} to={urlToNavigate(myFilters)}>{translator.decode("home.showStock")} </NavLink>
                        </div>
                    </div>
                    <video className={`${styles.picture}`} autoPlay={play} loop src="/testVideoAutoFi.mp4"></video>
                </div>
                <HomeBanner />
                <div className={`${styles.secI}`}>
                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.ourSelection")}</h2>
                    <CarSlider isPromo={true} orderList={{name:"id", order:"desc"}}/>
                </div>
                {/* <div className={`${styles.secII}`}>
                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.aboutUs")}</h2>
                    <AboutUs translate={true} imgDisplay={true} btnDisplay={true} bgColor={"var(--theme-bg-color)"} color={"var(--white)"} text={"home.aboutUsText"}/>
                </div> */}
                <div className={`${styles.secII}`}>
                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.ourEngagements")}</h2>
                    <Engagements/>
                </div>
                {
                    true ? null : <div className={`${styles.secII}`}>
                                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.ourPartners")}</h2>
                                    <Partners/>
                                </div>
                }
            </div>
            <div className={`${styles.btnContact}`}>
                <button className={`${styles.btnPhone}`} onClick={()=> setModalCta(true)} ><Phone size={"1.5rem"}/>{translator.decode("home.callBack")}</button>
                <NavLink to={RouterPathResolver.routeContact.path} className={`${styles.btnPhone}`}><MdMail size={"1.5rem"}/>{translator.decode("home.contact")}</NavLink>
            </div>
            <ModalCta show={modalCta} onClose={handleToggleCtaModal} closeModal={handleToggleCtaModal} themeColor={"themeColor"}/>
        </React.Fragment>
    );
}

export default HomeCardHolder;
